import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['input', 'display'];

    declare readonly inputTarget: HTMLInputElement;
    declare readonly displayTarget: HTMLElement;

    connect(): void {
        this.calculate();
    }

    calculate(): void {
        const value = this.inputTarget.value;
        const text = value ? this.format(this.computeAge(new Date(value))) : '';

        // El display puede ser un <input> (campo de formulario) o cualquier
        // otro elemento (badge/span): se actualiza con el valor cuando aplica.
        if (this.displayTarget instanceof HTMLInputElement) {
            this.displayTarget.value = text;

            return;
        }

        this.displayTarget.textContent = text;
    }

    private computeAge(birthday: Date): number {
        const today = new Date();
        let age = today.getFullYear() - birthday.getFullYear();
        const monthDiff = today.getMonth() - birthday.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthday.getDate())) {
            age--;
        }

        return age;
    }

    private format(age: number): string {
        return age >= 0 ? `${age}` : '';
    }
}
